/** Codes the console treats specially. The server's code sets only grow. */
export const SUBSCRIPTION_REQUIRED = "SUBSCRIPTION_REQUIRED";
export const FEATURE_NOT_IN_PLAN = "FEATURE_NOT_IN_PLAN";
/** The edge is holding the app for planned work: a 503 whose body carries this code. */
export const MAINTENANCE = "MAINTENANCE";
/** The server has not built this route yet. */
export const NOT_IMPLEMENTED = "NOT_IMPLEMENTED";

/** Used when the body carries no usable code, so a refusal always has one. */
export const UNKNOWN_CODE = "UNKNOWN";
